export const ANNOTATION_INFO_BUBBLE = 'annotation-info-bubble';
export const MODAL = 'modal';
export const PDP = 'pdp';
